import {
    navigateToD8EditionHelper,
    navigateToD8TexasEditionHelper,
    navigateToD8EditionAndTRCHelper,
    navigateToD8TexasEditionAndTRCHelper,
    navigateToOLSHelper,
    navigateToLecturaHelper,
    navigateToTRCSpanishHelper,
    navigateToOLSSpanishHelper,
    navigateToMathHelper,
} from '../navigation/navigation';
import { EDITIONS, APPLICATION_LIST_NAME } from '../../constants/applications';
import { isApplicationLicensed } from './licenseHelper';

const { DIBELS8, R3D, OLS, R3DSPANISH, OLS_SPANISH, MATHCBM, IDEL2 } = APPLICATION_LIST_NAME;
const { MCLASS_TX_EDITION } = EDITIONS;

const getHelpLinks = (edition, appConfigs, appPmConfigs) => {
    const isTexas = edition === MCLASS_TX_EDITION;

    let navigateToD8Helper = navigateToD8EditionHelper;
    let navigateToTRCHelper = navigateToD8EditionAndTRCHelper;

    if (isTexas) {
        navigateToD8Helper = navigateToD8TexasEditionHelper;
        navigateToTRCHelper = navigateToD8TexasEditionAndTRCHelper;
    }

    const linkConfigs = [
        {
            isLicensed:
                (isApplicationLicensed(appConfigs, DIBELS8) ||
                    isApplicationLicensed(appPmConfigs, DIBELS8)) &&
                !isApplicationLicensed(appConfigs, R3D),
            handleClick: navigateToD8Helper,
            title: 'DIBELS 8th Edition',
        },
        {
            isLicensed:
                isApplicationLicensed(appConfigs, DIBELS8) &&
                isApplicationLicensed(appConfigs, R3D),
            handleClick: navigateToTRCHelper,
            title: 'DIBELS 8th Edition and TRC',
        },
        {
            isLicensed:
                isApplicationLicensed(appConfigs, OLS) || isApplicationLicensed(appPmConfigs, OLS),
            handleClick: navigateToOLSHelper,
            title: 'Oral Language',
        },
        {
            isLicensed:
                isApplicationLicensed(appConfigs, IDEL2) ||
                isApplicationLicensed(appPmConfigs, IDEL2),
            handleClick: navigateToLecturaHelper,
            title: 'Lectura',
        },
        {
            isLicensed: isApplicationLicensed(appConfigs, R3DSPANISH),
            handleClick: navigateToTRCSpanishHelper,
            title: 'TRC Español',
        },
        {
            isLicensed:
                isApplicationLicensed(appConfigs, OLS_SPANISH) ||
                isApplicationLicensed(appPmConfigs, OLS_SPANISH),
            handleClick: navigateToOLSSpanishHelper,
            title: 'Oral Language Español',
        },
        {
            isLicensed: isApplicationLicensed(appConfigs, MATHCBM),
            handleClick: navigateToMathHelper,
            title: 'Math',
        },
    ];

    return linkConfigs.filter(link => link.isLicensed);
};

export default getHelpLinks;
